import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { initAppUpdate } from './utils/appUpdate'
import './styles/fonts.css'
import './styles/globals.css'

// Installed-app auto-update: reloads when a new service worker takes over and
// re-checks for releases while the tab stays open (see utils/appUpdate.ts).
initAppUpdate()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)
